import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { EmailService, XpoAngularUtilsModule } from '@xpo-ltl/angular-utils';
import { EmailService } from './utils/angular-utils/services';
import { XpoAngularUtilsModule } from './utils/angular-utils/xpo-angular-utils.module';
import { XpoLtlEmailService } from '@xpo-ltl/ngx-ltl';
import { ConditioningService, FormatValidationService } from '@xpo-ltl/common-services';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
// import { LoginModule } from '@xpo-ltl/login';
// import { AppMetadataApiService } from '@xpo-ltl/sdk-appmetadata';
import { AppMetadataApiService } from '@xpo-ltl-2.0/sdk-appmetadata';
import { CustomerApiService } from '@xpo-ltl/sdk-customer';
import { SdkElasticSearchModule } from '@xpo-ltl/sdk-elasticsearch';
import { LocationApiService } from '@xpo-ltl/sdk-location';
import { SdkLoggingModule } from '@xpo-ltl/sdk-logging';
import { SdkUserPreferenceModule } from '@xpo-ltl/sdk-userpreference';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { XPO_BROWSER_RESTRICTIONS, XpoBrowserGuardModule, XpoBrowserType } from '@xpo-ltl/ngx-ltl-core/browser-guard';
import { XpoAccountPopoverModule } from '@xpo-ltl/ngx-ltl-core/account-popover';
import { XpoAppSwitcherPopoverModule } from '@xpo-ltl/ngx-ltl-core/app-switcher-popover';
import { XpoHeaderModule } from '@xpo-ltl/ngx-ltl-core/header';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoLtlAuthConfigLoaderService, XpoLtlAuthenticationService, XpoLtlAuthModule } from '@xpo-ltl/ngx-auth';
import { XpoAuthConfig, XPO_AUTH_CONFIG } from '@xpo/ngx-auth';
import { XpoLtlGlobalSearchModule } from '@xpo-ltl/ngx-ltl-global-search';

import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { SdkDisputesModule } from '@xpo-ltl/sdk-disputes';
import { SdkHumanResourceModule } from '@xpo-ltl-2.0/sdk-humanresource';
import { CountryPickerModule } from 'ngx-country-picker';
import { NgxEditorModule } from 'ngx-editor';
import { AngularFireModule } from '@angular/fire/compat';

import { AngularSplitModule } from 'angular-split';

import { CurrencyCdPipe } from '../../lib/src/lib/notes-emails/pipes/currency-cd.pipe';
import { DocumentSearchPipe } from '../../lib/src/lib/notes-emails/pipes/document-search.pipe';
import { XpoPageNotFoundRoutingModule } from '@xpo-ltl/ngx-ltl-core/error-page';

import { SdkDocumentManagementModule } from '@xpo-ltl/sdk-documentmanagement';
import { AppDialogsModule } from './app-dialogs.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DisputesDialogModule } from './components/disputes/disputes-dialog.module';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { NotificationComponent } from './components/notification/notification.component';
import { MaterialModule } from './material.module';
import { HumanizePipe } from './pipes/humanize.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { AppConstantsService } from './services/app-constants.service';
import { environment } from 'src/environments/environment';

export function authConfigFactory(configService: XpoLtlAuthConfigLoaderService): XpoAuthConfig {
  configService.initSettings('../assets/config.json');

  return new XpoAuthConfig({
    appCode: configService.appCode,
    scopes: configService.scopes,
    isProd: configService.isProd,
    applicationRootUri: configService.appRootUri,
  });
}

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    NotAuthorizedComponent,
    NotificationComponent,
    DocumentSearchPipe,
    CurrencyCdPipe,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    ConfigManagerModule,
    // LoginModule,
    XpoAngularUtilsModule,
    AppDialogsModule,
    XpoHeaderModule,
    XpoAccountPopoverModule,
    XpoAppSwitcherPopoverModule,
    XpoButtonModule,
    XpoCardModule,
    XpoShellModule,
    XpoLtlGlobalSearchModule,
    XpoBrowserGuardModule,
    SdkDisputesModule,
    SdkElasticSearchModule,
    SdkHumanResourceModule,
    SdkLoggingModule,
    SdkUserPreferenceModule,
    CountryPickerModule.forRoot(),
    AngularSplitModule,
    DisputesDialogModule,
    SdkDocumentManagementModule,
    XpoLtlAuthModule.forRoot({
      provide: XPO_AUTH_CONFIG,
      useFactory: authConfigFactory,
      deps: [XpoLtlAuthConfigLoaderService],
    }),
    AppRoutingModule,
    NgxEditorModule,
    XpoPageNotFoundRoutingModule
  ],
  providers: [
    {
      provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
      useValue: { configFileUrl: '../assets/config.json' }
    },
    {
      provide: XPO_BROWSER_RESTRICTIONS,
      useValue: {
        blocked: [
          { browser: XpoBrowserType.InternetExplorer },
          { browser: XpoBrowserType.Edge },
          { browser: XpoBrowserType.Opera },
          { browser: XpoBrowserType.Safari },
          { browser: XpoBrowserType.Firefox },
        ],
        suggestions: [{ browser: XpoBrowserType.Chrome }],
      },
    },
    LocationApiService,
    AppConstantsService,
    AppMetadataApiService,
    DataApiService,
    NotificationService,
    EmailService,
    XpoLtlEmailService,
    XpoSnackBar,
    ConditioningService,
    FormatValidationService,
    CustomerApiService,
    HumanizePipe,
    XpoLtlAuthenticationService
  ],
  entryComponents: [NotAuthorizedComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
